import React from 'react';
import i18n from 'i18n-js';
import { createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() =>
    createStyles({
        tag: {
            backgroundColor: '#FFE4CC',
            border: '1px solid #ED994D',
            color: '#9E450A',
            borderRadius: 4,
            padding: '1px 5px',
            fontSize: 11,
            fontWeight: 700,
            lineHeight: '16px',
            textTransform: 'uppercase',
        },
    })
);

export default function WarmUpTag({ warmUp }: { warmUp?: boolean }) {
    const classes = useStyles();
    if (!warmUp) {
        return null;
    }

    return <span className={classes.tag}>{i18n.t('orders.warmUp')}</span>;
}
